export const listStyle = {
  cardActionStyle: {
    zIndex: 2,
    display: "inline-block",
    float: "right",

    iconStyle: {
      justifyContent: "flex-end",
      alignItems: "flex-end",
      marginBottom: "-25%"
    }
  },

  textFieldContainer: {
    display: "flex",
    alignItems: "center"
  },
  textFieldStyle: {
    paddingLeft: "5%",
    width: "100%"
  },
  booleanFieldStyle: {
    margin: 0
  }
};

export const formStyle = {
  containerInput: {
    float: "left",
    marginRight: "2%"
  },
  titleStyle: {
    textTransform: "capitalize"
  },

  clearFloatContainer: {
    clear: "both"
  }
};



// WEBPACK FOOTER //
// ./src/containers/CRM/Partners/style.js